const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment-timezone');
/**
 * Defines the media viewer component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('sessionPreview', [function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      session: '=?',
      instances: '=?',
      close: '&',
      isCohort: '=?'
    },
    template: require('../../templates/directives/session-preview.html'),
    controller: ['$scope', function ($scope) {
      const self = this;

      self.config = {
        loading: false
      };

      self.sortByDates = function(instanceArray) {
        return instanceArray.sort(function(a, b) {
          return new Date(a.start_date) - new Date(b.start_date);
        });
      };

      self.getInstanceOptions = function() {
        var guessedTz = moment.tz.guess();
        const sortedDates = self.sortByDates($scope.instances);
        self.instanceOptions = sortedDates.map(function(instance) {
          var venue = instance.online ? instance.online : instance.location.venue;
          var startMoment = moment(new Date(instance.start_date).valueOf()).tz(guessedTz);
          var option = startMoment.format('MMM D, YYYY') + ' \@ ' + startMoment.format('LT') + ' | ' + venue;
          return {
            name: option,
            value: instance._id
          };
        });
      };

      self.initialize = function() {
        self.config.loading = true;
        self.getInstanceOptions();
        self.config.loading = false;
      };

      self.initialize();

    }],
    controllerAs: 'preview'
  };
}]);